<ul class="list-container" role="list" [ngClass]="ngClass">
  <ng-content></ng-content>
</ul>
